"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideToolbox = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var ToolboxBody = styled_components_1.default.div.attrs({
    className: 'tws-side-toolbox',
    'data-testid': 'tws-side-toolbox',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: auto;\n\tposition: fixed;\n\ttop: ", ";\n\tmargin: 0 auto;\n\n\tdisplay: block;\n\twidth: 50px;\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\tborder-radius: 4px 0 0 4px;\n\tz-index: ", ";\n\tmargin-left: -51px;\n\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tword-break: break-word;\n\n\tdiv {\n\t\tborder-bottom: 2px solid ", ";\n\t}\n\tdiv:hover {\n\t\tbackground-color: ", " !important;\n\t}\n\tdiv:last-child {\n\t\tborder-bottom: none;\n\t}\n\tdiv:last-child:hover {\n\t\tborder-radius: 0 0 0 4px;\n\t}\n\tdiv:first-child:hover {\n\t\tborder-radius: 4px 0 0 0;\n\t}\n\t", "\n"], ["\n\theight: auto;\n\tposition: fixed;\n\ttop: ", ";\n\tmargin: 0 auto;\n\n\tdisplay: block;\n\twidth: 50px;\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\tborder-radius: 4px 0 0 4px;\n\tz-index: ", ";\n\tmargin-left: -51px;\n\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tword-break: break-word;\n\n\tdiv {\n\t\tborder-bottom: 2px solid ", ";\n\t}\n\tdiv:hover {\n\t\tbackground-color: ", " !important;\n\t}\n\tdiv:last-child {\n\t\tborder-bottom: none;\n\t}\n\tdiv:last-child:hover {\n\t\tborder-radius: 0 0 0 4px;\n\t}\n\tdiv:first-child:hover {\n\t\tborder-radius: 4px 0 0 0;\n\t}\n\t", "\n"])), function (props) { return (props.topPosition ? props.topPosition : '350px'); }, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.shadow1, globalVars_module_scss_1.default.layerDefault, globalVars_module_scss_1.default.mainGray, globalVars_module_scss_1.default.tertiaryGray3, function (props) {
    return !props.hasSidePad
        ? "\n\t@media (max-width: 768px) {\n\t\tmargin-left: 0;\n\t}"
        : '';
});
ToolboxBody.displayName = 'ToolboxBody';
var SideToolbox = function (props) {
    return react_1.default.createElement(ToolboxBody, __assign({}, props), props.children);
};
exports.SideToolbox = SideToolbox;
var templateObject_1;
